import Bluebird from 'bluebird';
import { filter, findIndex, findIndexes } from '../../../../../services/arrays';
import { CustomEvents } from '../../../../../services/custom-events';
import { assetPrefix } from '../../../services/app-storage';
import InputField from '../../../services/input-fields/input-field';
import { $id, fadeToggle, slideToggle } from '../../../services/jquery-utils';
import getTranslations from '../../../services/translations';
import { isDesktop } from '../storage';

class FieldError {
    public field: InputField;
    public message: string;

    constructor(field: InputField, message: string) {
        this.field = field;
        this.message = message;
    }
}

const errors: FieldError[] = [];
let globalField: InputField;

export function setError(field: InputField, message: string): void {
    removeError(field);
    const newError = new FieldError(field, message);
    console.log('Input error:', newError.message);
    removeErrorByMessage(newError.message);
    errors.push(newError);
}

export function removeError(field: InputField): void {
    const index = findIndex(errors, error => error.field.equals(field));
    if (typeof index === 'undefined') return;
    errors.splice(index);
}

function removeErrorByMessage(message: string): void {
    findIndexes(errors, x => x.message === message)
        .forEach(i => removeError(errors[i].field));
}

export const errorsExisting = () => errors.length !== 0;
export const setGlobalError = (errorMessage: string) => setError(globalField, errorMessage);
export const removeGlobalError = () => removeError(globalField);

let viewVisible = false;
let $container: JQuery, $containerChild: JQuery;

const getActiveErrors = () => filter(errors, x => x.field.$JQuery.is(':visible'));

function addErrorToView(message: string): void {
    $containerChild.append(`<div><img src="${assetPrefix}/images/flight/error-sign.png">`
        + `<span>${message}</span></div>`);
}

async function renderErrors(): Bluebird<void> {
    const t = await getTranslations('widget');
    $containerChild.empty();
    getActiveErrors().forEach(error => addErrorToView(error.message));
    $containerChild.append(`<div><span>${t['errors.suffix']}</span></div>`);
}

let viewAnimation = Bluebird.resolve();
function toggleView(show: boolean): Bluebird<void> {
    if (show === viewVisible) return Bluebird.resolve();

    viewVisible = show;
    if (show) {
        renderErrors();
    }

    const toggle = isDesktop ? slideToggle : fadeToggle;
    return viewAnimation = toggle($container, show).then(() => {
        if (!show) return renderErrors();
    });
}

export function updateErrorView(): Bluebird<void> {
    return toggleView(getActiveErrors().length > 0)
        .then(() => viewAnimation)
        .then(() => renderErrors());
}

export function loadErrors(): void {
    globalField = new InputField('searchButton');

    $container = $id('errorContainer');
    $containerChild = $container.find('> div');

    CustomEvents.subscribe('RemoveGlobalError', () => {
        removeGlobalError();
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/errors/errors.ts